import 'material-symbols/outlined.css';

import { sentryClient } from 'libs/observability/sentry';
import { ProductId } from 'core/modules/product/product/constants';
import { loadCurrentProductDetails } from 'core/modules/product/wl_product_current/controller';

// @ts-ignore vite fix
window.global = window;


// The hostname decides which product's settings (name, colors, logo) load. This app only runs Payroll.
// eslint-disable-next-line promise/catch-or-return
loadCurrentProductDetails().then(({ product_id }) => {
  if (product_id !== ProductId.Payroll) {
    sentryClient?.captureException(new Error('Product not found: productId=' + product_id));
    return import('product/productNotFound');
  }
  return import('./app');
}).catch((e) => {
  console.error(e);
  return import('product/productNotLoaded');
});
